export const flightSortTypeForConsultation: any = {
  recommended: "Recommended",
  duration: "Shortest Duration",
  price: "Lowest Price",
};
